import { Company } from 'src/app/shared/libs/models/context.model';
import { DateRange } from './dateRange';
import { Status } from './status';
import { PaginationFilters } from './paginationFilters';
import { OrderFilters } from './order';
import { Brand } from './brand.model';

export class Photographer {
	hired?: DateRange;
	discount?: PhotographerDiscount;
	automaticRenewal?: boolean;
	maxItems?: number;
	contractId?: number;
	active?: boolean;
	brands?: Brand[];
	status?: Status;
	company?: Company;
	shotCost?: number;
	totalPaid?: number;
	monthlyPaid?: number;
	id?: number;
	firstName?: string;
	lastName?: string;
	fullName?: string;

	constructor(init?: Partial<Photographer>) {
		Object.assign(this, init);
	}
}

export class PhotographerDiscount {
	percentage?: number;
	treshold?: number;

	constructor(init?: Partial<PhotographerDiscount>) {
		Object.assign(this, init);
	}
}

export class PhotographerFilters extends PaginationFilters {
	brands?: Brand[];
	contractDate?: DateRange;
	statuses?: Status[];
	textSearch?: string;

	constructor(init?: Partial<PhotographerFilters>) {
		super(init);
		Object.assign(this, init);
	}
}

export class PhotographerValitation {
	firstName: boolean = true;
	lastName: boolean = true;
	status: boolean = true;
	hired: boolean = true;
	brands: boolean = true;
	automaticRenewal: boolean = true;
	maxItems: boolean = true;

	constructor(init?: Partial<PhotographerValitation>) {
		Object.assign(this, init);
	}
}

/*
 {
	"id": 1,
	"tag": "OnTrial"
},
{
	"id": 2,
	"tag": "Hired"
},
{
	"id": 3,
	"tag": "Refused"
},
{
	"id": 4,
	"tag": "Requested"
},
{
	"id": 5,
	"tag": "Rejected"
},
{
	"id": 6,
	"tag": "Dismissed"
},
{
	"id": 7,
	"tag": "Deleted"
}

*/

export enum PhotographerStatus {
	ON_TRIAL = 1,
	HIRED = 2,
	REFUSED = 3,
	REQUESTED = 4,
	REJECTED = 5,
	DISMISSED = 6,
	DELETED = 7
}
